<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "commondescrMain",
      key: "id",
      url: {
        get: "/admin/system/common",
        add: "/admin/system/common",
        edit: "/admin/system/common",
      },
      id: "",
      typeId: "",
      items: [
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
        },
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "报修/维修",
          name: "workType",
          value: 2,
          type: "select",
          width: "400px",
          dropList: [
            { value: 2, name: "维修内容" },
            { value: 3, name: "故障原因" },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "常用语句",
          name: "descr",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
      ],
      forms: {},
    };
  },
  created() {
    let query = this.$route.query;
    if (query.action == "edit") {
      this.id = query.kv;
      this.handleSearch();
    }
  },
  methods: {
    async handleSearch() {
      let res = await $utils.api.load(`/admin/system/common/${this.id}`);
      try {
        if (res) {
          this.forms = res.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    handleSubmit() {
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        this.sloading = true;
        $utils.api
          .load(`/admin/system/common`, q, this.action == "edit" ? "PUT" : "POST")
          .then((res) => {
            this.sloading = false;
            if (res.status) {
              $utils.toast.success("保存成功");
              $utils.url.go(-1);
            }
          })
          .catch((e) => {
            this.sloading = false;
            $utils.toast.error("保存异常" + e.message);
          });
      });
    },
  },
};
</script>
